import { render, staticRenderFns } from "./Waterfall.vue?vue&type=template&id=3fa39f20"
import script from "./Waterfall.vue?vue&type=script&lang=js"
export * from "./Waterfall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports